module.exports = __webpack_public_path__ + "static/media/gratitude-most-ignored-virtue-that-inspires-people.cf6f78f4.svg";